import EquipmentLabourGrid from './grid.equipment-labour'

export default EquipmentLabourGrid